


class ExchangeSummaryTable extends DataTable {

  constructor(order, table_id) {

    super(table_id, false);
    this.order = order;
    this.searching = false;
    this.paging = false;
    this.info = false;
    this.domOptions = "<'no_padding row'<'col-sm-12'tr>>";

    this.useJsData = true;

    this.setupTable();

  }
  ordering() {
    return [[ 0, "desc" ]]
  }

  rowCallback(row, data) {
  }

  getTableColumns() {
    var columnArray = [

                { "data": "exchange__slug" },
                { "data": "exchange_fee_currency__slug" },
                { "data": "exchange_filled_fee",
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(6))
                  }},
                { "data": "exchange_filled_qty",
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(6))
                  }},
                { "data": "net_executed_quantity",
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(8))
                  } },
                { "data": "gross_consideration",
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(6))
                    } },
                { "data": "net_consideration",
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(6))
                    } },

            ]
            return columnArray
          }

  _getTableAjax() {
    return this.order.exchange_summary_stats
  }

  refresh(order) {
    var old_data = JSON.stringify(this._getTableAjax());
    this.order = order;
    if (old_data !== JSON.stringify(this._getTableAjax())) {
      this.table.clear();
      this.table.rows.add(this._getTableAjax());
      this.table.draw(null, false);
    } else {
      //console.log("json equals");
    }


  }




}

class FeeSummaryTable extends ExchangeSummaryTable {
  getTableColumns() {
    var columnArray = [

                { "data": "exchange_fee_currency__slug" },
                { "data": "exchange_filled_fee",
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(8))
                  }},

                { "data": "net_executed_quantity",
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(8))
                  } },

                { "data": "net_consideration",
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(8))
                    } },

            ]
            return columnArray
          }

  _getTableAjax() {
    //console.log(this.order.fee_summary_stats);
    return this.order.fee_summary_stats
  }

}
